import { FormInitialData } from "types/form/formInitialData";
import {
  BorrowerNaturalFormValues,
  BorrowerInsuredFormFieldNames
} from "features/subscription-process/profiling-process/forms/borrower-insured";
import { ReferentialDto } from "api/risk";
import { ActorType } from "features/new-actor/enums/actorType";
import { mapBorrowerNaturalPerson } from "./mapBorrowerNaturalPerson";
import { ReferentialKey } from "api/referential";
import { PossibleAnswer } from "features/subscription-process/profiling-process/types/interfaces";
import { BorrowerNaturalPersonDto } from "api/borrower";

export const mapActorTypeBorrower = (
  actorType: ActorType,
  borrowerEntity: BorrowerNaturalPersonDto,
  referentialData: Record<ReferentialKey, ReferentialDto[]>,
  surveyForm?: Record<string, PossibleAnswer>,
): FormInitialData<ActorType, BorrowerNaturalFormValues> | undefined => {
  if (actorType === ActorType.BorrowerNatural) {
    return {
      [actorType]: {
        ...mapBorrowerNaturalPerson(borrowerEntity, referentialData),
        [BorrowerInsuredFormFieldNames.SurveyForm]: surveyForm
      }
    };
  }
};
